import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron_double",
  "use": "chevron_double-usage",
  "viewBox": "0 0 6 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 10\" id=\"chevron_double\"><path d=\"M2.2 4.2l.8-.8.8.8c.2.2.4.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4L3 .6.8 2.8c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0zm1.6 1.6l-.8.8-.8-.8c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4L3 9.4l2.2-2.2c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol